import { ValidationInputType } from "@cak-legacy/generation-core";
import { FileAbstractValidation } from "./FileAbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class HasFileMinSizeValidation extends FileAbstractValidation {
  key = "hasFileMinSize";
  constructor(
    private readonly minSizeInBytes: number,
    customErrorMessage?: CustomErrorMessage,
    private readonly customFileErrorMessage?: CustomErrorMessage
  ) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (!value) {
      return true;
    }

    if (typeof value === "string") {
      return true;
    }

    const hasUploadedFilesSmallerThenMinSize = this.getFiles(value).some((file) => !this.isValidFile(file));
    return !hasUploadedFilesSmallerThenMinSize;
  };

  isValidFile = (file: File) => {
    return file.size > this.minSizeInBytes;
  };

  defaultMessage = (label: string): string =>
    translate("Generation_Form_{label}MoetMinimaal{mizSizeInBytes}Zijn", { label: label, mizSizeInBytes: (this.minSizeInBytes + 1).toString() });

  fileErrorMessage = (fileLabel: string): string =>
    this.customFileErrorMessage
      ? this.customFileErrorMessage(fileLabel)
      : translate("Generation_Form_{fileLabel}MoetMinimaal{mizSizeInBytes}Zijn", { fileLabel: fileLabel, mizSizeInBytes: (this.minSizeInBytes +  1).toString() });
}
